import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { mainnet, arbitrum, holesky } from '@reown/appkit/networks';
import type { AppKitNetwork } from '@reown/appkit/networks';
import { createConfig, http } from 'wagmi';

export const projectId = '024709ec0f5c1243961d1a12c735fb5b';

if (!projectId) {
    throw new Error('Project ID is not defined');
}

export const metadata = {
    name: 'TTM Partners',
    description: '',
    url: 'https://ttmpartners.net',
    icons: [
        'https://raw.githubusercontent.com/RustPo/logo-storage/92c561e05613037bf12841ecb8e68976e7c2183a/favicon.svg',
    ],
};

export const networks = [mainnet, holesky] as [AppKitNetwork, ...AppKitNetwork[]];

export const wagmiAdapter = new WagmiAdapter({
    projectId,
    networks,
    chains: [mainnet, holesky],
    transports: {
        [mainnet.id]: http(),
        [holesky.id]: http(),
    },
});
